export const slaChip = (m) => {
  if (m.status !== "new") return null;
  const replies = Array.isArray(m.replies) ? m.replies : [];
  const last = replies.length ? replies[replies.length - 1] : null;
  if (last && last.direction === "outbound") return null; // awaiting sender, not us
  const since = last && last.direction === "inbound" ? last.at : m.created_at;
  const hrs = Math.floor((Date.now() - new Date(since).getTime()) / 3600000);
  const label = hrs < 1 ? "<1h" : hrs < 24 ? `${hrs}h` : `${Math.floor(hrs / 24)}d`;
  const tone = hrs >= 24 ? "bg-red-100 text-red-700" : hrs >= 4 ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700";
  return { label, tone };
};

export const timeAgo = (iso) => {
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
};

export const isImage = (path) => /\.(jpg|jpeg|png|gif|webp)$/i.test(path || "");

export const isOverdue = (m) =>
  m.category === "design" &&
  (m.design_status || "new") !== "delivered" &&
  (Date.now() - new Date(m.created_at).getTime()) >= 48 * 3600000;
